import React from 'react';

const PricingCard = ({ title, price, period, description, onSelect, showButtons, badge, isHighlighted }) => {
  return (
    <div
      className={`relative overflow-visible rounded-2xl backdrop-blur-sm border-2 p-6 sm:p-8 group transition-all duration-300 flex flex-col justify-between h-full hover:shadow-xl hover:-translate-y-2 ${isHighlighted ? 'border-primary transform lg:scale-110' : 'border-border'
        }`}
      style={{
        background: 'var(--color-background-secondary)',
      }}
    >
      {/* Badge for yearly card */}
      {badge && (
        <div className="absolute top-0 -translate-y-1/2 w-full flex justify-center z-20">
          <span className="px-3 py-1 text-xs font-semibold tracking-wider text-white uppercase bg-primary rounded-full shadow-lg drop-shadow-sm">
            {badge}
          </span>
        </div>
      )}

      {/* Content */}
      <div className="relative z-10">
        <h3 className="text-lg sm:text-xl font-semibold mb-4 sm:mb-6 text-content-primary drop-shadow-sm">
          {title}
        </h3>
        <div className="mb-3 sm:mb-4">
          <span className="text-3xl sm:text-4xl font-bold text-content-primary drop-shadow-sm">
            {price}
          </span>
          <span className="text-base sm:text-lg ml-1 opacity-90 text-content-secondary">
            {period}
          </span>
        </div>
        <p className="opacity-90 text-content-secondary drop-shadow-sm text-sm sm:text-base">
          {description}
        </p>
      </div>

      {/* Button */}
      {showButtons && (
        <div className="relative z-10 mt-6 sm:mt-8">
          {isHighlighted ? (
            <button
              onClick={() => onSelect(title)}
              className="w-full py-3 rounded-xl font-semibold transition-all duration-300 text-white drop-shadow-sm hover:scale-105 active:scale-95 text-sm sm:text-base"
              style={{
                background: 'var(--color-primary)',
                boxShadow: '0 4px 12px var(--color-primary)30',
              }}
            >
              Choose {title}
            </button>
          ) : (
            <button
              onClick={() => onSelect(title)}
              className="w-full py-3 rounded-xl font-semibold transition-all duration-300 bg-background-primary hover:bg-border text-content-primary hover:scale-105 active:scale-95 drop-shadow-sm text-sm sm:text-base"
            >
              Choose {title}
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export const PricingCards = ({ onSelectPlan, showButtons = true }) => (
  <div className="mt-8 sm:mt-12 max-w-5xl mx-auto grid grid-cols-1 lg:grid-cols-3 gap-6 sm:gap-8 items-center px-4 sm:px-0">
    <PricingCard
      title="Monthly"
      price="$5.99"
      period="/ month"
      description="Flexible, cancel anytime."
      onSelect={onSelectPlan}
      showButtons={showButtons}
    />

    <PricingCard
      title="Yearly"
      price="$59.99"
      period="/ year"
      description="Best Value Option."
      onSelect={onSelectPlan}
      showButtons={showButtons}
      badge="Save over 15%!"
      isHighlighted
    />

    <PricingCard
      title="Lifetime"
      price="$149.99"
      period="one-time"
      description="Pay once, learn forever."
      onSelect={onSelectPlan}
      showButtons={showButtons}
    />
  </div>
);